import { useEffect, useState } from 'react';

import apiOffers from 'api/offers';

// Position codes are compared without case and surrounding spaces, e.g. "ak1 " is AK1
const normalize = (position: string): string => position.trim().toUpperCase();

/** Whether the position code is already used by another position of the offer */
export const isPositionInUse = (
  position: string,
  usedPositions: string[]
): boolean =>
  normalize(position) !== '' &&
  usedPositions.some((used) => normalize(used) === normalize(position));

/**
 * The position codes (AK1, AK2…) of the other positions of the offer or the additional
 * offer, for telling the user when a code is already in use.
 */
export const useUsedPositions = (
  parentId: number | null,
  isAdditionalOffer: boolean,
  offerProductId?: number
): string[] => {
  const [usedPositions, setUsedPositions] = useState<string[]>([]);

  useEffect(() => {
    if (parentId === null || Number.isNaN(parentId)) {
      return undefined;
    }

    let cancelled = false;

    const load = async () => {
      try {
        const positions = isAdditionalOffer
          ? await apiOffers.products.getForAdditionalOffer(parentId)
          : await apiOffers.products.getForOffer(parentId);

        if (!cancelled) {
          setUsedPositions(
            positions
              .filter((position) => position.id !== offerProductId)
              .map((position) => position.position ?? '')
          );
        }
      } catch (error) {
        // Without the positions the code is just not checked
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [isAdditionalOffer, offerProductId, parentId]);

  return usedPositions;
};
